module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigator d-flex justify-content-between"
  }, [_c('div', [(_vm.getSelectedEventListReservations) ? _c('h2', {
    staticClass: "mr-auto"
  }, [_c('span', [_vm._v(_vm._s(_vm.filterEventName))]), _vm._v(" "), _c('span', {
    staticClass: "fs-smaller darker ml-2 pointer underlined",
    on: {
      "click": _vm.removeEventFilter
    }
  }, [_vm._v("All activities")])]) : _c('h2', {
    staticClass: "mr-auto"
  }, [_vm._v("Reservations")])]), _vm._v(" "), (!_vm.getSelectedEventListReservations) ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('v-select', {
    staticClass: "mr-3 reservationMainFilter",
    attrs: {
      "options": _vm.viewOptions,
      "label": "name"
    },
    on: {
      "input": _vm.viewOptionsChanged
    },
    model: {
      value: (_vm.selectedFilters.selectedView),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilters, "selectedView", $$v)
      },
      expression: "selectedFilters.selectedView"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "ico ico-calendar fs-large dark mr-3"
  }), _vm._v(" "), _c('date-picker-new', {
    key: _vm.pickerKey,
    staticClass: "dateRangePicker",
    attrs: {
      "range": true,
      "clearOutside": true,
      "showFromTo": false
    },
    on: {
      "input": _vm.dateRangeChanged
    },
    model: {
      value: (_vm.selectedFilters.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilters, "dateRange", $$v)
      },
      expression: "selectedFilters.dateRange"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-75b76d36", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b76d36"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Navigator.vue
// module id = 2701
// module chunks = 0